import React from 'react';
import { Typography, Tag } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import useSubscriptionCountdown from '../hooks/useSubscriptionCountdown';

export default function SubscriptionCountdown({
  endDate,
  active = true,
  tagColor = 'blue',
  label = 'Time remaining',
  expiredLabel = 'Expired',
}) {
  const { formattedCountdown, isExpired } = useSubscriptionCountdown(endDate, { active });

  if (!endDate || !formattedCountdown) {
    return null;
  }

  return (
    <Typography.Text type="secondary" style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <ClockCircleOutlined />
      <span>{label}:</span>
      <Tag color={isExpired ? 'error' : tagColor} style={{ margin: 0, fontVariantNumeric: 'tabular-nums' }}>
        {isExpired ? expiredLabel : formattedCountdown}
      </Tag>
    </Typography.Text>
  );
}
